export function resolveHookState(newState, currentState) {
    if (typeof newState === 'function') {
        return newState(currentState);
    }
    return newState;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/esm/util/resolveHookState.js
// module id = null
// module chunks = 